import { Minimize2, Maximize2 } from 'lucide-react';
import { useThemeStore } from '@/stores/theme';

export function DensityToggle() {
  const { density, toggleDensity } = useThemeStore();

  return (
    <button
      onClick={toggleDensity}
      className="density-toggle-btn"
      title={density === 'compact' ? 'Switch to cozy mode' : 'Switch to compact mode'}
      aria-label={density === 'compact' ? 'Switch to cozy mode' : 'Switch to compact mode'}
    >
      {density === 'compact' ? <Maximize2 size={15} /> : <Minimize2 size={15} />}
    </button>
  );
}
